import type { CampaignTypes } from 'entities/campaign';

export const campaignTypeToTextMapper: Record<keyof typeof CampaignTypes, string> = {
  appt: 'appointments',
  lead: 'leads',
  sales: 'sales',
};
